<template>
	<div class="left-tab">
		<div style="margin-top: 20px">
			<el-menu style="border: none" :default-active="defaultopen">
				<div
					v-for="(item, index) in tabList"
					:key="item.index"
					@click="getPush(item.url, item.index)"
					:style="{ marginTop: index != 0 ? '40px' : '0px' }"
				>
					<el-menu-item :index="item.index" v-if="item.show">
						<template #title>
							<img
								:src="defaultopen == item.index ? item.showicon : item.icon"
								alt="logo"
								style="width: 40px; height: 40px"
							/>
							<p style="text-align: center; padding: 5px 0">{{ item.name }}</p>
						</template>
						<el-menu-item-group
							v-for="(child, index) in item.children"
							:key="index"
							:index="child.index"
						>
							<template #title>
								<img :src="child.icon" alt="logo" style="width: 25px; height: 25px" />
								<p>{{ child.name }}</p>
							</template>
						</el-menu-item-group>
					</el-menu-item>
				</div>
			</el-menu>
		</div>
		<div class="bottom-tab" v-if="active == 'KEFU_ADMIN'">
			<el-switch v-model="showReceive" @change="noReceive"> </el-switch>
			<div class="bottom-text">暂不接待</div>
		</div>
	</div>
</template>
<script setup>
import router from "@/router";
import { ref, onMounted, watch } from "vue";
import { post, get } from "../utils/request";
const active = ref(sessionStorage.getItem("userType"));
const defaultopen = ref("1");
const showReceive = ref(false);
import { message } from "@/utils/resetMessage";
const repeat = ref(0);
const tabList = ref([
	{
		index: "1",
		name: "历史",
		icon: require("../assets/light_icon_news.png"),
		showicon: require("../assets/icon_news.png"),
		url: "/HistotyRrecord",
		show: true,
		children: [],
	},
	{
		index: "2",
		name: "设置",
		url: "/RootSetting",
		icon: require("../assets/icon_settings.png"),
		showicon: require("../assets/lin_icon_settings.png"),
		show: sessionStorage.getItem("userType") != "KEFU" ? true : false,
		children: [],
	},
	{
		index: "3",
		name: "会话",
		url: "/Chart",
		icon: require("../assets/no_meeting.png"),
		showicon: require("../assets/up_meeting.png"),
		show: sessionStorage.getItem("userType") == "KEFU" ? true : false,
		children: [],
	},
]);
onMounted(() => {
	tabList.value.forEach((item) => {
		if (window.location.href.includes(item.url)) {
			defaultopen.value = item.index;
		}
	});
	getReport();
});
const getReport = () => {
	get(`/api-cms/reception/report`).then((res) => {
		if (res.code == 1) {
			repeat.value = res.result.reception;
			if (res.result.reception == 1) {
				showReceive.value = false;
			} else {
				showReceive.value = true;
			}
		}
	});
};
const noReceive = () => {
	get(`/api-cms/reception/report`).then((res) => {
		if (res.code == 1) {
			if (res.result.kefuOnline > 0) {
				if (showReceive.value) {
					repeat.value = 0;
				} else {
					repeat.value = 1;
				}
				post(`/api-cms/reception/status?status=${repeat.value}`).then((res) => {
					if (res.code == 1) {
					}
				});
			}else{
				getReport()
				message.error("暂无客服上线，无法开始接待，请稍后再试");
			}
		}
	});
};
watch(
	() => router.currentRoute.value,
	(newval, oldval) => {
		tabList.value.forEach((item) => {
			if (window.location.href.includes(item.url)) {
				defaultopen.value = item.index;
			}
		});
	}
);
const getPush = (url, index) => {
	defaultopen.value = index;
	router.push(url);
};
</script>
<style scoped lang="less">
.left-tab {
	height: 100%;
}
.el-menu-item {
	display: block;
	line-height: 14px;
	height: 100%;
	text-align: center;
	width: 138px;
}
.el-menu {
	padding: 0;
}
.el-menu-item.is-active {
	color: #a15bff;
}
.bottom-text {
	font-size: 14px;
	color: #999999;
	line-height: 22px;
	margin-left: 10px;
}
.bottom-tab {
	position: absolute;
	bottom: 46px;
	left: 15px;
	display: flex;
	align-items: center;
}
</style>
